module.exports = __webpack_public_path__ + "img/18.1eab3064.jpg";